<template>
  <div style="width:100%;height:calc(100% );overflow: hidden;" v-loading="loading">
    <iframe
      id="myIframe"
      runat="server"
      :src="src"
      width="100%"
      height="100%"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
      allowtransparency="yes"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      src: "",
      loading: false,
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      let iframe = document.getElementById("myIframe");
      iframe.onload = iframe.onreadystatechange = this.iframeload;
      this.loading = true;
      this.src = this.$store.getters.getIframeLayoutSrc;
    });
  },
  methods: {
    iframeload() {
      this.loading = false;
    },
    
  },
  watch: {
    "$store.state.iframeLayoutSrc": function(newVal, oldVal) {
      this.loading = true;
      this.src = newVal;
    },
  },
};
</script>
<style lang="less" scoped>
#myIframe {
    display: block;  /* iframes are inline by default */
    background: #fff;
    border: none;   /* Reset default border */
    height: 100vh;   /* Viewport-relative units */
    width: 100vw;
}
</style>
